export default "__VITE_ASSET__C_PnTt0i__"